import { Theme, Typography } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { memo } from 'react'

import { IFeatures } from './typings'

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    featuresContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
      paddingLeft: 20,
      [theme.breakpoints.down('md')]: {
        borderRight: 'none',
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        margin: '20px',
        paddingLeft: 10,
      },
    },
    headerText: {
      fontWeight: '700',
      fontSize: 18,
      marginTop: -30,
      [theme.breakpoints.down('md')]: {
        marginTop: 20,
      },
    },
    checkIcon: {
      color: theme.palette.primary.main,
      fontSize: 24,
    },
    crossIcon: {
      color: theme.palette.error.main,
      fontSize: 24,
    },
    featuresTextContainerCls: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 10,
    },
  }),
)
const Features = ({ features }: IFeatures) => {
  const {
    featuresContainer,
    checkIcon,
    crossIcon,
    headerText,
    featuresTextContainerCls,
  } = useStyles()

  return (
    <div className={featuresContainer}>
      <Typography className={headerText}>Sie können online</Typography>
      <span className={featuresTextContainerCls}>
        {features.documentUpload ? (
          <CheckOutlinedIcon className={checkIcon} />
        ) : (
          <CloseOutlinedIcon className={crossIcon} />
        )}
        <Typography sx={{ marginLeft: '10px' }}>Dokumente hochladen</Typography>
      </span>
      <span className={featuresTextContainerCls}>
        {features.videoIdent ? (
          <CheckOutlinedIcon className={checkIcon} />
        ) : (
          <CloseOutlinedIcon className={crossIcon} />
        )}
        <Typography sx={{ marginLeft: '10px' }}>
          Ihre Identität per Videoident nachweisen
        </Typography>
      </span>
      <span className={featuresTextContainerCls}>
        {features.onlineSignature ? (
          <CheckOutlinedIcon className={checkIcon} />
        ) : (
          <CloseOutlinedIcon className={crossIcon} />
        )}
        <Typography sx={{ marginLeft: '10px' }}>
          den Vertrag digital unterzeichnen
        </Typography>
      </span>
    </div>
  )
}

export default memo(Features)
